import script from "./ApplyOnOK.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplyOnOK.vue?vue&type=script&setup=true&lang=ts"

import "./ApplyOnOK.vue?vue&type=style&index=0&id=43ddb64c&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ddb64c"]])

export default __exports__